/*
 * @Description:
 * @Author: ywj
 * @Date: 2025-01-22 09:32:45
 * @LastEditTime: 2025-04-14 11:51:30
 * @LastEditors: Please set LastEditors
 */
import React from 'react';
import { useRoutes, Navigate } from 'react-router-dom';
import Home from '@/views/home';
import List from '@/views/list';
import ProductDetail from '@/views/productDetail';
import PersonalCenter from '@/views/personal-center';
import Invoice from '@/views/personal-center/invoice';
import Personal from '@/views/personal-center/personal';
import Address from '@/views/personal-center/address';
import Payment from '@/views/personal-center/payment';
import MyOrderList from '@/views/personal-center/myOrder';
import OrderDetail from '@/views/personal-center/orderDetail';
// import ProductOrder from '@/views/order/index';
import CreateOrder from '@/views/personal-center/order';
import ShoppingCart from '@/views/shoppingCart';
import PaymentSuccess from '@/views/personal-center/payment/payment-success'
import MyInvoice from '@/views/personal-center/my-invoice';
import Coupon from '@/views/personal-center/coupon'
import ApplyService from '@/views/personal-center/applyService';
import AfterService from '@/views/personal-center/afterService';
import ServiceDetail from '@/views/personal-center/serviceDetail';
// import cookie from 'react-cookies';

// const lng = cookie.load('lang') === 'en-US' ? 'en' : 'zh';

export const routerConfig = [
  {
    path: '',
    title: '本源商城首页',
    element: <Home />,
  },
  {
    path: 'home',
    children: [
      {
        index: true,
        title: '本源商城首页',
        element: <Home />,
      },
    ],
  },
  {
    path: 'shop/search',
    children: [
      {
        index: true,
        title: '所有产品-本源商城',
        element: <List />,
      },
    ],
  },
  {
    path: 'detail',
    children: [
      {
        index: true,
        title: 'detail',
        element: <ProductDetail />,
      },
    ],
  },
  {
    path: 'user',
    element: <PersonalCenter />,
    children: [
      {
        index: true,
        // path: 'user',
        title: '个人中心',
        element: <Personal />,
      },
      {
        path: 'invoice',
        title: '开票',
        element: <Invoice />,
      },
      {
        path: 'address',
        title: '收货信息',
        element: <Address />,
      },
      {
        path: 'orderList/:id?',
        title: '我的订单',
        element: <MyOrderList />,
      },
      {
        path: 'confirm/:id?',
        title: '创建订单',
        element: <CreateOrder />,
      },
      {
        path: 'order/detail/:id',
        title: '订单详情',
        element: <OrderDetail />,
      },
      {
        path: 'receipt',
        title: '我的发票',
        element: <MyInvoice />,
      }, 
      {
        path: 'coupon',
        title: '优惠券',
        element: <Coupon />,
      },
      {
        path: 'as/:id',
        title: '申请售后',
        element: <ApplyService />
      },
      {
        path: 'as/List',
        title: '售后服务',
        element: <AfterService />
      },
      {
        path: 'as/detail/:id',
        title: '售后详情',
        element: <ServiceDetail />
      }
    ],
  },
  {
    path: 'user/cart',
    title: '购物车',
    element: <ShoppingCart />,
  },
  {
    path: 'user/payment',
    title: '支付',
    element: <Payment />,
  },
  {
    path: 'user/payment/success',
    title: '支付成功',
    element: <PaymentSuccess />,
  },
  {
    path: '*',
    element: <Navigate to={`/`} />,
  },
];

// 递归处理路由，加上国际化标记
// const routersconfig = (list:any) =>
//   list.length > 0
//     ? list.map((r:any) => ({
//         ...r,
//         path: `/${lng}${r.path}`,
//         routes: r?.routes?.length > 0 ? routersconfig(r?.routes) : r?.routes,
//       }))
//     : list;

const RouterView = () => {
  return useRoutes(routerConfig);
};

export default RouterView;
